import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class HeaderCategoryProxy extends ProxyBase {
  getHeaderActiveStatus(params) {
    return this.get('ActiveStatus', params)
  }

  getHeaderLocation(params) {
    return this.get(
      'Location',
      params,
      undefined,
      'HeaderCategoryProxy/getHeaderLocation',
    )
  }
}

export default new HeaderCategoryProxy('Category/')
